<template>
    <button @click="reset()" type="button" class="btn text-uppercase btn-sm btn-info btn-block">
        {{text}}
    </button>
</template>
<script>
    import { Comandos } from '../../class';
    import { Bus } from '../../class/bus';

    export default {
        name: 'HabilitarHodmetroMetragem',
        props: {
            text: {
                default: "Habilitar em Metros"
            },
            id_rastreador: {
                "default": null
            },
            valor: {
                default: 1
            }
        },
        methods: {
            async reset () {
                await Comandos.habilitarHodometroMetragem(this.id_rastreador, this.valor);
                Bus.$emit('comandos');
            }
        }
    }
</script>
